export enum PRODUCT_NAME {
    ACCOUNT_ADMIN = "Account Admin",
    AGENT = "Agent",
    ALLOCATOR = "Allocator",
    FORMS_PLUS = "FormsPlus",
    MUNICIPAL = "Municipal",
    PREMIUM = "Premium",
    MIGRATION = "Migration"
}